import { render, staticRenderFns } from "./ReviewsCategoriesTableSearchBox.vue?vue&type=template&id=fe4cc8fe&scoped=true&"
import script from "./ReviewsCategoriesTableSearchBox.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesTableSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesTableSearchBox.vue?vue&type=style&index=0&id=fe4cc8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4cc8fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
